import { render, staticRenderFns } from "./jhdp.vue?vue&type=template&id=3ffd8c74&"
import script from "./jhdp.vue?vue&type=script&lang=js&"
export * from "./jhdp.vue?vue&type=script&lang=js&"
import style0 from "./jhdp.vue?vue&type=style&index=0&id=3ffd8c74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports